import styled from 'styled-components'

export const ButtonGroup = styled.div`
  display: flex;
  flex-direction: column;
  > button:first-of-type {
    margin-bottom: ${props => props.theme.spacing};
  }
  @media(min-width: 768px) {
    flex-direction: row;
    width: fit-content;
    > button:first-of-type {
      margin-bottom: 0px;
      margin-right: ${props => props.theme.spacing};
    }
  }
`